import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { distinct } from "@entrilia/shared/utilities/arrayHelper";
import type { CitationReference } from "../../../../../api/types/workflowTypes";

interface Props {
  citations: CitationReference[];
  onViewCitations: (documentName: string) => void;
}

const WorkflowActivityCitations = ({ citations, onViewCitations }: Props) => {
  const documentNames = distinct(citations.map((c) => c.documentName));

  return (
    <Stack direction="row" sx={{ gap: 1, alignItems: "center", flexWrap: "wrap", pt: 2 }}>
      <Typography variant="subtitle2">Sources:</Typography>
      {documentNames.map((documentName) => {
        const documentCitations = citations.filter((c) => c.documentName === documentName);
        const isDeleted = documentCitations.every((c) => c.highlightResolution?.status === "DocumentDeleted");
        if (isDeleted) {
          return (
            <Tooltip key={documentName} title="The original file was removed by a user">
              <span>
                <Chip label="Source removed" disabled />
              </span>
            </Tooltip>
          );
        }
        return <Chip key={documentName} label={documentName} onClick={() => onViewCitations(documentName)} />;
      })}
    </Stack>
  );
};

export default WorkflowActivityCitations;
